import type { CollisionProximity } from "@common/utils/redline/text/card-collisions";

export function conflictLabelOf(proximity: CollisionProximity): string {
  if (proximity === "changes_same_words") return "changes the same words differently";
  if (proximity === "inserts_at_same_spot") return "adds text at the same spot";
  if (proximity === "edits_nearby") return "edits made nearby";
  if (proximity === "same_sentence") return "modifies the same sentence";
  return "redline identical to it";
}

export function infoPrefixOf(proximity: CollisionProximity): string {
  if (proximity === "edits_nearby") return "Edits made near";
  if (proximity === "same_sentence") return "Modifies the same sentence as";
  if (proximity === "makes_same_change") return "Redline identical to";
  return "Related to";
}

export function joinedCardNumbersOf(cardNumbers: number[]): string {
  const labels = cardNumbers.map((cardNumber) => `#${cardNumber}`);
  if (labels.length <= 1) return labels.join("");
  return `${labels.slice(0, -1).join(", ")} & ${labels[labels.length - 1]}`;
}

export function groupPredicateOf(proximity: CollisionProximity): string {
  if (proximity === "changes_same_words") return "change the same words differently";
  if (proximity === "inserts_at_same_spot") return "add text at the same spot";
  if (proximity === "edits_nearby") return "edit words next to each other";
  if (proximity === "same_sentence") return "modify the same sentence";
  return "make the same change";
}

export function groupSummaryOf(cardNumbers: number[], proximity: CollisionProximity): string {
  return `${joinedCardNumbersOf(cardNumbers)} ${groupPredicateOf(proximity)}`;
}

export const SAME_CHANGE_NOTE = "also has a redline identical to it";
